module.exports = __webpack_public_path__ + "static/shader-032aa15b1e11005d236bdce8d8daefbf.gif";